var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTypeYear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 9,
    viewBox: "0 0 27 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_2424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0110728 8.18011H5.50897V6.88909H2.22587C3.51688 5.79839 5.33099 4.32936 5.33099 2.44848C5.33099 1.03505 4.45174 0 2.70442 0C1.24647 0 0.0556346 0.856972 0 2.71555H1.51352C1.52486 1.85858 1.9365 1.32441 2.68216 1.32441C3.45009 1.32441 3.77284 1.81412 3.77284 2.53752C3.77284 4.02885 1.84743 5.46451 0.0110728 7.02266V8.18011Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.49072 4.12897C6.49072 6.49953 7.20295 8.26911 9.49561 8.26911C11.7883 8.26911 12.5006 6.49953 12.5006 4.12897C12.5006 1.78064 11.7883 0.0222168 9.49561 0.0222168C7.20295 0.0222168 6.49072 1.78064 6.49072 4.12897ZM10.9647 4.12897C10.9647 5.57577 10.809 6.82226 9.49561 6.82226C8.18234 6.82226 8.0265 5.57577 8.0265 4.12897C8.0265 2.73776 8.18227 1.46901 9.49561 1.46901C10.8089 1.46901 10.9647 2.73776 10.9647 4.12897Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5969 8.18011H19.0948V6.88909H15.8116C17.1026 5.79839 18.9167 4.32936 18.9167 2.44848C18.9167 1.03505 18.0374 0 16.2901 0C14.8322 0 13.6413 0.856972 13.5857 2.71555H15.0993C15.1107 1.85858 15.5222 1.32441 16.2679 1.32441C17.0358 1.32441 17.3585 1.81412 17.3585 2.53752C17.3585 4.02885 15.4332 5.46451 13.5969 7.02266V8.18011Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0767 4.12897C20.0767 6.49953 20.789 8.26911 23.0817 8.26911C25.3743 8.26911 26.0866 6.49953 26.0866 4.12897C26.0866 1.78064 25.3743 0.0222168 23.0817 0.0222168C20.789 0.0222168 20.0767 1.78064 20.0767 4.12897ZM24.5508 4.12897C24.5508 5.57577 24.3951 6.82226 23.0817 6.82226C21.7684 6.82226 21.6126 5.57577 21.6126 4.12897C21.6126 2.73776 21.7683 1.46901 23.0817 1.46901C24.3949 1.46901 24.5508 2.73776 24.5508 4.12897Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_2424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.0865,
    height: 8.26915,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTypeYear);
export default __webpack_public_path__ + "static/media/icon_type_year.4b4ca281d4c1d79a3d0a4dfb6086355e.svg";
export { ForwardRef as ReactComponent };